export const IntegrationTestCaseExpectationCheckerSchema = {
  type: 'array',
  items: {
    $ref: '#/definitions/IntegrationTestCaseExpectationChecker',
  },
  definitions: {
    IntegrationTestCaseExpectationChecker: {
      title: 'CheckerSchema',
      type: 'object',
      properties: {
        description: { title: 'Description to identify checker case', default: '', type: 'string' },
        filter_by: {
          title: 'Filter to find message(s) to run the checker',
          default: {
            strategy: 'message:filter:id',
            headers: null,
            message_id: null,
            correlation_code: null,
            order_by: 'created_at',
          },
          allOf: [{ $ref: '#/definitions/IntegrationTestMessageFilterByDefinition' }],
        },
        strategy: {
          title: 'Checker strategy to be used',
          enum: ['checker:message-count', 'checker:message-payload', 'checker:message-headers'],
          type: 'string',
        },
        strategy_definition: {
          title: 'Definitions for Checker Strategy',
          anyOf: [
            { $ref: '#/definitions/CheckerMessageCountDefinition' },
            { $ref: '#/definitions/CheckerMessageBodyDefinition' },
            { $ref: '#/definitions/CheckerMessageHeaderDefinition' },
            { $ref: '#/definitions/CheckerMessageReceiptDefinition' },
            { $ref: '#/definitions/CheckerMessageLookupEntriesDefinition' },
          ],
        },
      },
      required: ['strategy', 'strategy_definition'],
    },
    IntegrationTestMessageFilterByDefinition: {
      title: 'Filter Message by Definition',
      type: 'object',
      properties: {
        strategy: {
          title: 'Strategy to Filter Messages for Assertion',
          enum: ['message:filter:id', 'message:filter:correlation-code', 'message:filter:headers'],
          type: 'string',
        },
        headers: {
          title: 'Filter by Headers',
          description: 'Always filtered by header Integration-Test-Execution',
          type: 'object',
        },
        message_id: {
          title: 'Message ID to be filtered (expression)',
          description: 'Default is message.id',
          type: 'string',
        },
        correlation_code: {
          title: 'Correlation Code to be filtered (expression)',
          description: 'Default is message.correlation_code',
          type: 'string',
        },
        order_by: {
          title: 'Order message filter by',
          default: 'created_at',
          enum: ['created_at', '-created_at'],
          options: { enum_titles: ['Created At - Asc', 'Created At - Desc'] },
          type: 'string',
        },
      },
      required: ['strategy'],
    },
    CheckerMessageCountDefinition: {
      title: 'Message Count Checker Definition',
      type: 'object',
      properties: {
        expected_count: { title: 'Expected Number of Messages to assert', type: 'integer' },
      },
      required: ['expected_count'],
    },
    CheckerMessageBodyDefinition: {
      title: 'Message Body Checker Definition',
      type: 'object',
      properties: {
        expected_body: { title: 'Expected Message Body to assert', type: 'string' },
      },
      required: ['expected_body'],
    },
    CheckerMessageHeaderDefinition: {
      title: 'Message Headers Checker Definition',
      type: 'object',
      properties: { expected_headers: { title: 'Expected Headers to assert', type: 'object' } },
      required: ['expected_headers'],
    },
    CheckerMessageReceiptDefinition: {
      title: 'Message Receipt Checker Definition',
      type: 'object',
      properties: {
        status_code: { title: 'Status Code to the Receipt', type: 'integer' },
        receipt_type: { title: 'Type of the Receipt', type: 'string' },
        expected_payload: { title: 'Expected Payload of the Receipt', type: 'string' },
      },
      required: ['status_code', 'receipt_type', 'expected_payload'],
    },
    CheckerMessageLookupEntriesDefinition: {
      title: 'Message Lookup Entries Checker Definition',
      type: 'object',
      properties: {
        lookup_name: { title: 'Lookup Table name (expression)', type: 'string' },
        lookup_key: { title: 'Lookup Table Key (expression)', type: 'string' },
        lookup_content: { title: 'Lookup Table Content to assert', type: 'object' },
      },
      required: ['lookup_name', 'lookup_key'],
    },
  },
}

export const IntegrationTestCaseExpectationCheckerSchemaUiSchema = {
  type: 'Control',
  scope: '#/',
  options: {
    detail: {
      type: 'VerticalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/description',
        },
        {
          type: 'Categorization',

          elements: [
            {
              type: 'Category',
              label: 'Filter',
              elements: [
                {
                  type: 'Control',
                  scope: '#/properties/filter_by',
                },
              ],
            },
            {
              type: 'Category',
              label: 'Assertion',
              elements: [
                {
                  type: 'VerticalLayout',
                  elements: [
                    {
                      type: 'Control',
                      scope: '#/properties/strategy',
                    },
                    {
                      type: 'Control',
                      scope: '#/properties/strategy_definition',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  },
}
